const CLAIMED_PROFILE_FIELDS = [
  "title",
  "logo",
  "phone",
  "description",
  "address",
  "city",
  "state",
  "zipCode",
  "email",
  "active",
];

const STARTUP_PROFILE_FIELDS = [
  ...CLAIMED_PROFILE_FIELDS,
  "social",
];

export function getEditableProfileFields(subscription) {
  const configured = subscription?.plan?.postKinds?.profile?.editableFields;
  if (Array.isArray(configured)) {
    return configured
      .map((field) => String(field || "").trim())
      .filter((field) => field && field !== "website" && field !== "domain");
  }

  const planName = String(subscription?.plan?.name || "").trim().toLowerCase();
  if (["startup", "starter", "growth", "pro"].includes(planName)) {
    return STARTUP_PROFILE_FIELDS;
  }

  return CLAIMED_PROFILE_FIELDS;
}

const PROFILE_FIELD_DEFAULTS = {
  title: { name: "title", label: "Business Name", type: "text", required: true },
  logo: {
    name: "logo",
    label: "Logo",
    type: "image",
    aspect: 1,
    mimeType: "image/png",
    description: "Use a square logo canvas. You can zoom out to fit a wide logo; transparent PNG backgrounds are preserved.",
  },
  phone: { name: "phone", label: "Phone", type: "text" },
  description: { name: "description", label: "Introduction", type: "rtf" },
  address: { name: "address", label: "Business Address", type: "text" },
  city: { name: "city", label: "City", type: "text" },
  state: { name: "state", label: "State", type: "text" },
  zipCode: { name: "zipCode", label: "ZIP Code", type: "text" },
  email: { name: "email", label: "Email", type: "email" },
  active: {
    name: "active",
    label: "Active",
    type: "boolean",
    description: "Show this business in public search results.",
  },
  social: {
    name: "social",
    label: "Social Profiles",
    type: "social",
    handles: [
      { name: "facebook", label: "Facebook" },
      { name: "instagram", label: "Instagram" },
      { name: "tiktok", label: "TikTok" },
      { name: "youtube", label: "YouTube" },
    ],
  },
};

export function getEditableProfileFormFields(form, subscription) {
  const fields = Array.isArray(form?.fields) ? form.fields : [];
  const fieldsByName = new Map(fields.map((field) => [field?.name, field]));

  return getEditableProfileFields(subscription)
    .map((name) => {
      const configured = fieldsByName.get(name);
      const defaults = PROFILE_FIELD_DEFAULTS[name];
      return configured && defaults ? { ...defaults, ...configured, ...(name === "logo" ? defaults : {}) } : configured || defaults;
    })
    .filter(Boolean);
}
